import type { ReactElement } from 'react';

import { MeetingPairCsvImportPage } from '@/features/events/MeetingPairCsvImportPage';

/** サクセス面談組み合わせCSV一括作成（D-274） */
export function SuccessMeetingCsvImportPage(): ReactElement {
  return <MeetingPairCsvImportPage kind="success-meeting" />;
}
